/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LocalizationTranslateGet$Plain$Params {
  languageCode?: string;
  scope?: string;
  key?: string;
}

export function localizationTranslateGet$Plain(http: HttpClient, rootUrl: string, params?: LocalizationTranslateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, localizationTranslateGet$Plain.PATH, 'get');
  if (params) {
    rb.query('languageCode', params.languageCode, {});
    rb.query('scope', params.scope, {});
    rb.query('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

localizationTranslateGet$Plain.PATH = '/localization/translate';
